export const reject_codes = {
    UNAUTHORIZED: 41701,
    TOKEN_EXPIRED: 41702,
    VALIDATION_FAILED: 41703,
    ITEM_NOT_FOUND: 41710,

}

